import { ServiceRequest } from "src/utils/service-request"
import { CALC_SETORIAL_PATH, CALC_GROUP_INDICATOR_PATH, CALC_GROUP_ACTIVE_PATH, CALC_SETOR_LIST_PATH, CALC_SUBSETOR_LIST_PATH } from "src/utils/api-routes"

const addIdToEndpoint = (endpoint, id) => {
    const queryIndex = endpoint.indexOf("?")

    if (queryIndex === -1) return `${endpoint}/${id}`

    return `${endpoint.slice(0, queryIndex)}/${id}${endpoint.slice(queryIndex)}`
}

class CalcService {

    constructor() {
        this.serviceRequest = new ServiceRequest()
    }

    async loadEndpoint(endpoint) {
        const separator = endpoint.includes("?") ? "&" : "?"
        return await this.serviceRequest.get(`${endpoint}${separator}limit=10000`)
    }

    async createTableEndpoint(endpoint, body) {
        return await this.serviceRequest.post(`${endpoint}`, body)
    }

    async updateTableEndpoint(endpoint, id, body) {
        return await this.serviceRequest.patch(addIdToEndpoint(endpoint, id), body)
    }

    async deleteTableEndpoint(endpoint, id) {
        return await this.serviceRequest.delete(addIdToEndpoint(endpoint, id))
    }

    async recuperaDadosSetor(input, value) {
        return this.serviceRequest.get(`${CALC_SETORIAL_PATH}?${input}=${value}`)
    }

    async recuperaGrupoAtivos(tiposEmissao = ['Corporate', 'IF', 'IF_IQ', 'Soberano']) {
        const response = await this.serviceRequest.get(`${CALC_GROUP_ACTIVE_PATH}`)
        const data = response?.body?.results || []

        return data
            .filter(item => tiposEmissao.includes(item.TipoEmissao))
            .map(item => ({
                value: item.TipoAtivo,
                label: `${item.TipoAtivo} (${item.GrupoAtivos})`
            }))
    }
    async recuperaIndicador() {
        const response = await this.serviceRequest.get(CALC_GROUP_INDICATOR_PATH)


        const data = response?.body?.results || []


        return data.map(item => ({
            indicador: item.Indicador
        }))
    }

    async recuperaSetores() {
        const response = await this.serviceRequest.get(CALC_SETOR_LIST_PATH)

        const data = response?.body?.results || response?.body || []

        return data.map(item => ({
            value: item,
            label: item
        }))
    }

    async recuperaSubsetores(setor = null) {
        const query = setor ? `?setor=${setor}` : ''

        const response = await this.serviceRequest.get(`${CALC_SUBSETOR_LIST_PATH}${query}`)

        const data = response?.body || []

        return data.map(item => ({
            value: item,
            label: item
        }))
    }


}

export default CalcService